import {
  Box,
  Divider,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
} from "@chakra-ui/react";

import { useIsOnProtectedRoute } from "utils/hooks/useIsOnProtectedRoute";

import { ChakraText } from "components/ChakraText";

import { LettersSpacingButton } from "../AccessibilityButtons/LettersSpacingButton";
import { NormalLettersButton } from "../AccessibilityButtons/NormalLettersButton";
import { MediumLettersButton } from "../AccessibilityButtons/MediumLettersButton";
import { BigLettersButton } from "../AccessibilityButtons/BigLettersButton";
import { DarkModeButton } from "../AccessibilityButtons/DarkModeButton";
import { MobileGroups } from "./MobileGroups";
import { MobileProtectedRoutes } from "./MobileProtectedRoutes";

interface IProps {
  isOpen: boolean;
  onClose: () => void;
}

const SideDrawer = ({ isOpen, onClose }: IProps) => {
  const isOnProtectedRoute = useIsOnProtectedRoute();

  return (
    <Drawer isOpen={isOpen} placement="right" onClose={onClose}>
      <DrawerOverlay>
        <DrawerContent>
          <DrawerCloseButton mt={2} />
          <DrawerHeader>
            <ChakraText>Menu</ChakraText>
          </DrawerHeader>
          <Divider />

          <Box pl="6" d="flex">
            <LettersSpacingButton />
            <NormalLettersButton />
            <MediumLettersButton />
            <BigLettersButton />
            <DarkModeButton />
          </Box>

          <Divider />

          <DrawerBody d="flex">
            {isOnProtectedRoute ? (
              <MobileProtectedRoutes onCloseDrawer={onClose} />
            ) : (
              <MobileGroups onCloseDrawer={onClose} />
            )}
          </DrawerBody>
        </DrawerContent>
      </DrawerOverlay>
    </Drawer>
  );
};

export default SideDrawer;
